import { CanActivateFn } from '@angular/router';

export const passwordResetRedirectGuard: CanActivateFn = () => {
  return true;
};
